import {
    DEALERADDUPDATEUNIONLIST_FAILED,
    DEALERADDUPDATEUNIONLIST_SUCCESS,
    RESET_DEALERADDUPDATEUNIONLIST,
    LOADING_DEALERADDUPDATEUNIONLIST,
    NETWORK_ERROR_DEALERADDUPDATEUNIONLIST
} from '../types/index';


const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
}


export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERADDUPDATEUNIONLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERADDUPDATEUNIONLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERADDUPDATEUNIONLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERADDUPDATEUNIONLIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERADDUPDATEUNIONLIST:
            return (state = initialState);
        default:
            return state;
    }
};